import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { FallbackProps } from "react-error-boundary";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { errorPageTrns, metaTrns } from "src/page-components/error/trns";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Link } from "src/components/Link";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { PATHNAMES } from "src/constants/routes";

const ErrorPage: FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation();

  return (
    <MetadataWrapper
      title={t(metaTrns.title)}
      description={t(metaTrns.description)}
    >
      <PageWrapper>
        <div className="bg-cover bg-center bg-no-repeat bg-about-us-banner-mobile md:bg-about-us-banner">
          <div className="container flex flex-col items-center justify-center gap-10 max-w-172 mx-auto pt-40 pb-48 lg:pt-72 lg:pb-96">
            <h1 className="text-center text-purple-base text-20 gl:text-52">
              {t(errorPageTrns.title)}
            </h1>

            <p className="text-purple-base gl:text-xl text-center font-thin max-w-172">
              {t(errorPageTrns.description)}
            </p>

            <div className="flex gap-3">
              <Link href={PATHNAMES.HOME}>
                <Button
                  className="md:text-xl font-medium px-5 py-3 w-full sm:w-auto"
                  variant={ButtonVariants.PRIMARY}
                  onClick={resetErrorBoundary}
                >
                  {t(errorPageTrns.goHomeBtn)}
                </Button>
              </Link>
              <Link href={PATHNAMES.CONTACT_US}>
                <Button
                  className="md:text-xl font-medium px-5 py-3 w-full sm:w-auto"
                  variant={ButtonVariants.PRIMARY}
                  onClick={resetErrorBoundary}
                >
                  {t(errorPageTrns.contactUsBtn)}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default ErrorPage;
